// login.action
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOG_OUT = "LOG_OUT";

// toast.action
export const SUCCESS_TOAST = "SUCCESS_TOAST";
export const WARNING_TOAST = "WARNING_TOAST";
export const RESET_WARNING_TOAST = "RESET_WARNING_TOAST";
export const ERROR_TOAST = "ERROR_TOAST";
export const RESET_ERROR_TOAST = "RESET_ERROR_TOAST";
export const RESET_SUCCESS_TOAST = "RESET_SUCCESS_TOAST";

// permissions.action
export const FETCH_PERMISSIONS = "FETCH_PERMISSIONS";

// roleList.action
export const FETCH_ROLE_LIST = "FETCH_ROLE_LIST";

// roleView.action
export const FETCH_ROLE = "FETCH_ROLE";
export const RESET_ROLE = "RESET_ROLE";

// userList.action
export const FETCH_USER_LIST = "FETCH_USER_LIST";

// userView.action
export const FETCH_USER = "FETCH_USER";
export const RESET_USER = "RESET_USER";

// pgModuleView.action
export const FETCH_PG_VIEW = "FETCH_PG_VIEW";
export const RESET_PG_VIEW = "RESET_PG_VIEW";

// kitTransferView.action
export const FETCH_KIT_TRANSFER = "FETCH_KIT_TRANSFER";
export const RESET_KIT_TRANSFER = "RESET_KIT_TRANSFER";

// productList.action
export const FETCH_PRODUCT_LIST = "FETCH_PRODUCT_LIST";
export const RESET_PRODUCT_LIST = "RESET_PRODUCT_LIST";

// productView.action
export const FETCH_PRODUCT = "FETCH_PRODUCT";
export const RESET_PRODUCT = "RESET_PRODUCT";

// productCategoryList.action
export const FETCH_PRODUCT_CATEGORY_LIST = "FETCH_PRODUCT_CATEGORY_LIST";
export const RESET_PRODUCT_CATEGORY_LIST = "RESET_PRODUCT_CATEGORY_LIST";
//userProductCategoryList.action
export const FETCH_USER_PRODUCT_CATEGORY_LIST =
  "FETCH_USER_PRODUCT_CATEGORY_LIST";

// productCategoryView.action.js
export const FETCH_PRODUCT_CATEGORY = "FETCH_PRODUCT_CATEGORY";
export const RESET_PRODUCT_CATEGORY = "RESET_PRODUCT_CATEGORY";

// productBrandList.action
export const FETCH_PRODUCT_BRAND_LIST = "FETCH_PRODUCT_BRAND_LIST";
export const RESET_PRODUCT_BRAND_LIST = "RESET_PRODUCT_BRAND_LIST";
// ds1BrandList.action
export const FETCH_DS1_BRAND_LIST = "FETCH_DS1_BRAND_LIST";
export const RESET_DS1_BRAND_LIST = "RESET_DS1_BRAND_LIST";
// ds1CatalogueList.action
export const FETCH_DS1_CATALOGUE_LIST = "FETCH_DS1_CATALOGUE_LIST";
export const RESET_DS1_CATALOGUE_LIST = "RESET_DS1_CATALOGUE_LIST";
// ds1ProductList.action
export const FETCH_DS1_PRODUCT_LIST = "FETCH_DS1_PRODUCT_LIST";
export const RESET_DS1_PRODUCT_LIST = "RESET_DS1_PRODUCT_LIST";
// ds1ProductFilters.action
export const FETCH_DS1_PRODUCT_FILTERS = "FETCH_DS1_PRODUCT_FILTERS";
export const RESET_DS1_PRODUCT_FILTERS = "RESET_DS1_PRODUCT_FILTERS";
// ds1AllProducts.action
export const FETCH_DS1_ALL_PRODUCTS = "FETCH_DS1_ALL_PRODUCTS";
export const RESET_DS1_ALL_PRODUCTS = "RESET_DS1_ALL_PRODUCTS";
// ds1AllProductFilters.action
export const FETCH_DS1_ALL_PRODUCT_FILTERS = "FETCH_DS1_ALL_PRODUCT_FILTERS";
export const RESET_DS1_ALL_PRODUCT_FILTERS = "RESET_DS1_ALL_PRODUCT_FILTERS";
// ds1ProductVariantOverview.action
export const FETCH_DS1_PRODUCT_VARIANT_OVERVIEW =
  "FETCH_DS1_PRODUCT_VARIANT_OVERVIEW";
export const RESET_DS1_PRODUCT_VARIANT_OVERVIEW =
  "RESET_DS1_PRODUCT_VARIANT_OVERVIEW";
// masterDataList.action
export const FETCH_MASTER_DATA_LIST = "FETCH_MASTER_DATA_LIST";
export const RESET_MASTER_DATA_LIST = "RESET_MASTER_DATA_LIST";

// productBrandView.action
export const FETCH_PRODUCT_BRAND = "FETCH_PRODUCT_BRAND";
export const RESET_PRODUCT_BRAND = "RESET_PRODUCT_BRAND";

// productUnitList.action
export const FETCH_PRODUCT_UNIT_LIST = "FETCH_PRODUCT_UNIT_LIST";

// productUnitView.action
export const FETCH_PRODUCT_UNIT = "FETCH_PRODUCT_UNIT";
export const RESET_PRODUCT_UNIT = "RESET_PRODUCT_UNIT";

// productPackagingList.action
export const FETCH_PRODUCT_PACKAGING_LIST = "FETCH_PRODUCT_PACKAGING_LIST";
export const RESET_PRODUCT_PACKAGING_LIST = "RESET_PRODUCT_PACKAGING_LIST";

// productPackagingView.action
export const FETCH_PRODUCT_PACKAGING = "FETCH_PRODUCT_PACKAGING";
export const RESET_PRODUCT_PACKAGING = "RESET_PRODUCT_PACKAGING";

// shelfLifeList.action
export const FETCH_SHELF_LIFE_LIST = "FETCH_SHELF_LIFE_LIST";

// productStatusList.action
export const FETCH_PRODUCT_STATUS_LIST = "FETCH_PRODUCT_STATUS_LIST";

// warehouseList.action
export const FETCH_WAREHOUSE_LIST = "FETCH_WAREHOUSE_LIST";
export const RESET_WAREHOUSE_LIST = "RESET_WAREHOUSE_LIST";

// IncidentList.action
export const FETCH_INCIDENT_LIST = "FETCH_INCIDENT_LIST";
export const RESET_INCIDENT_LIST = "RESET_INCIDENT_LIST";

// TechnicianLogs.action
export const FETCH_TECHNICIAN_LOGS = "FETCH_TECHNICIAN_LOGS";
export const RESET_TECHNICIAN_LOGS = "RESET_TECHNICIAN_LOGS";

// MotorActionLogsView.action
export const FETCH_MOTOR_ACTION = "FETCH_MOTOR_ACTION";
export const RESET_MOTOR_ACTION = "RESET_MOTOR_ACTION";

// MotorActionLogs.action
export const FETCH_MOTOR_ACTION_LOGS = "FETCH_MOTOR_ACTION_LOGS";
export const RESET_MOTOR_ACTION_LOGS = "RESET_MOTOR_ACTION_LOGS";

export const FETCH_INCIDENT_TYPE_LIST = "FETCH_INCIDENT_TYPE_LIST" ; 
export const RESET_INCIDENT_TYPE_LIST = "RESET_INCIDENT_TYPE_LIST" ; 

// JobList.action
export const FETCH_JOB_LIST = "FETCH_JOB_LIST";
export const RESET_JOB_LIST = "RESET_JOB_LIST";

// JobOverview.action
export const FETCH_JOB = "FETCH_JOB";
export const RESET_JOB = "RESET_JOB";

// warehouseListOrder.action
export const FETCH_WAREHOUSE_ORDER_LIST = "FETCH_WAREHOUSE_ORDER_LIST";
export const RESET_WAREHOUSE_ORDER_LIST = "RESET_WAREHOUSE_ORDER_LIST";

// warehouseView.action
export const FETCH_WAREHOUSE = "FETCH_WAREHOUSE";
export const RESET_WAREHOUSE = "RESET_WAREHOUSE";

// refiler permission list action
export const FETCH_REFILLER_PERMISSION = "FETCH_REFILLER_PERMISSION";
export const RESET_REFILLER_PERMISSION = "RESET_REFILLER_PERMISSION ";

// refiler permission list action
export const FETCH_TECHNICIAN_PERMISSION = "FETCH_TECHNICIAN_PERMISSION";
export const RESET_TECHNICIAN_PERMISSION = "RESET_TECHNICIAN_PERMISSION ";

// refiler notification permission list action
export const FETCH_REFILLER_NOTIFICATION = "FETCH_REFILLER_NOTIFICATION";
export const RESET_REFILLER_NOTIFICATION = "RESET_REFILLER_NOTIFICATION";

export const FETCH_TECHNICIAN_NOTIFICATION = "FETCH_TECHNICIAN_NOTIFICATION";
export const RESET_TECHNICIAN_NOTIFICATION = "RESET_TECHNICIAN_NOTIFICATION";

// StatesCitiesData.action
export const FETCH_COUNTRIES_DATA = "FETCH_COUNTRIES_DATA";
export const RESET_COUNTRIES_DATA = "RESET_COUNTRIES_DATA";
export const FETCH_STATES_DATA_BY_COUNTRY = "FETCH_STATES_DATA_BY_COUNTRY";
export const FETCH_STATES_DATA = "FETCH_STATES_DATA";
export const FETCH_CITIES_DATA = "FETCH_CITIES_DATA";
export const RESET_CITIES_DATA = "RESET_CITIES_DATA";
export const RESET_STATES_DATA = "RESET_STATES_DATA";
export const FETCH_OTHER_COUNTRIES_DATA = "FETCH_OTHER_COUNTRIES_DATA";
export const RESET_OTHER_COUNTRIES_DATA = "RESET_OTHER_COUNTRIES_DATA";
export const FETCH_OTHER_STATES_DATA_BY_COUNTRY =
  "FETCH_OTHER_STATES_DATA_BY_COUNTRY";
export const RESET_OTHER_STATES_DATA_BY_COUNTRY =
  "RESET_OTHER_STATES_DATA_BY_COUNTRY";
export const FETCH_OTHER_CITIES_DATA = "FETCH_OTHER_CITIES_DATA";
export const RESET_OTHER_CITIES_DATA = "RESET_OTHER_CITIES_DATA";
export const FETCH_APPLICABLE_STATES = "FETCH_APPLICABLE_STATES";
export const FETCH_APPLICABLE_CITIES = "FETCH_APPLICABLE_CITIES";

// zoneList.action
export const FETCH_ZONE_LIST = "FETCH_ZONE_LIST";

// zoneView.action
export const FETCH_ZONE = "FETCH_ZONE";
export const RESET_ZONE = "RESET_ZONE";

// inventory.action
export const FETCH_INVENTORY = "FETCH_INVENTORY";
export const RESET_INVENTORY = "RESET_INVENTORY";

// deliveryPartnerList.action
export const FETCH_DELIVERY_PARTNER_LIST = "FETCH_DELIVERY_PARTNER_LIST";

// deliveryPartnerView.action
export const FETCH_DELIVERY_PARTNER = "FETCH_DELIVERY_PARTNER";
export const RESET_DELIVERY_PARTNER = "RESET_DELIVERY_PARTNER";

// franchiseList.action
export const FETCH_FRANCHISE_LIST = "FETCH_FRANCHISE_LIST";
export const RESET_FRANCHISE_LIST = "RESET_FRANCHISE_LIST";

// retailers.action
export const FETCH_RETAILERS_LIST = "FETCH_RETAILERS_LIST";
export const RESET_RETAILERS_LIST = "RESET_RETAILERS_LIST";

//warehouse visible retailers.action
export const FETCH_WAREHOUSE_VISIBLE_RETAILERS_LIST =
  "FETCH_WAREHOUSE_VISIBLE_RETAILERS_LIST";
export const RESET_WAREHOUSE_VISIBLE_RETAILERS_LIST =
  "RESET_WAREHOUSE_VISIBLE_RETAILERS_LIST";

//warehouse visible retailers.action
export const FETCH_PURCHASE_APPROVAL_ADMIN_LIST =
  "FETCH_PURCHASE_APPROVAL_ADMIN_LIST";
export const RESET_PURCHASE_APPROVAL_ADMIN_LIST =
  "RESET_PURCHASE_APPROVAL_ADMIN_LIST";

// retailers.action
export const FETCH_MODELS_LIST = "FETCH_MODELS_LIST";
export const RESET_MODELS_LIST = "RESET_MODELS_LIST";

// retailers.action
export const FETCH_MANUFACTURERS_LIST = "FETCH_MANUFACTURERS_LIST";
export const RESET_MANUFACTURERS_LIST = "RESET_MANUFACTURERS_LIST";

// retailer.action
export const FETCH_RETAILER = "FETCH_RETAILER";
export const RESET_RETAILER = "RESET_RETAILER";

// franchiseView.action
export const FETCH_FRANCHISE = "FETCH_FRANCHISE";
export const RESET_FRANCHISE = "RESET_FRANCHISE";

// storeList.action.js
export const FETCH_STORE_LIST = "FETCH_STORE_LIST";
export const RESET_STORE_LIST = "RESET_STORE_LIST";
// storeView.action.js
export const FETCH_STORE = "FETCH_STORE";
export const RESET_STORE = "RESET_STORE";

// shippingList.action
export const FETCH_SHIPPING_LIST = "FETCH_SHIPPING_LIST";

//createShippingOrder.action

export const FETCH_CREATE_SHIPPING_PARAMETERS =
  "FETCH_CREATE_SHIPPING_PARAMETERS";
export const RESET_CREATE_SHIPPING_PARAMETERS =
  "RESET_CREATE_SHIPPING_PARAMETERS";

// shippingView.action
export const FETCH_SHIPPING = "FETCH_SHIPPING";
export const RESET_SHIPPING = "RESET_SHIPPING";

// vmList.action
export const FETCH_VM_LIST = "FETCH_VM_LIST";
export const RESET_VM_LIST = "RESET_VM_LIST";

//offerDestinationList.action
export const FETCH_OFFER_DESTINATION_LIST = "FETCH_OFFER_DESTINATION_LIST";

//offerDestinationList.action
export const FETCH_OFFER_TYPES_LIST = "FETCH_OFFER_TYPES_LIST";

// vmStockAvailability.action.
export const FETCH_VM_STOCK_AVAILABILITY = "FETCH_VM_STOCK_AVAILABILITY";
export const RESET_VM_STOCK_AVAILABILITY = "RESET_VM_STOCK_AVAILABILITY";

// restrictedProductList.action
export const FETCH_RESTRICTED_PRODUCT_LIST = "FETCH_RESTRICTED_PRODUCT_LIST";
export const RESET_RESTRICTED_PRODUCT_LIST = "RESET_RESTRICTED_PRODUCT_LIST";

// deletedVMList.action
export const FETCH_DELETED_VM_LIST = "FETCH_DELETED_VM_LIST";

// hardwareBoard.action
export const FETCH_HARDWARE_BOARD_LIST = "FETCH_HARDWARE_BOARD_LIST";

// vmView.action
export const FETCH_VM = "FETCH_VM";
export const RESET_VM = "RESET_VM";

// paymentTypes.action
export const FETCH_PAYMENT_TYPES = "FETCH_PAYMENT_TYPES";

// storeInventory.action
export const FETCH_STORE_INVENTORY = "FETCH_STORE_INVENTORY";

// refillList.action
export const FETCH_REFILL_LIST = "FETCH_REFILL_LIST";
export const RESET_REFILL_LIST = "RESET_REFILL_LIST";

//refillListFilter.action
export const FETCH_REFILL_LIST_FILTER = "FETCH_REFILL_LIST_FILTER";
export const RESET_REFILL_LIST_FILTER = "RESET_REFILL_LIST_FILTER";
export const FETCH_REFILL_LIST_CHIP_FILTER = "FETCH_REFILL_LIST_CHIP_FILTER";

//warehouseListFilter.action
export const FETCH_WAREHOUSE_LIST_FILTER = "FETCH_WAREHOUSE_LIST_FILTER";
export const RESET_WAREHOUSE_LIST_FILTER = "RESET_WAREHOUSE_LIST_FILTER";
export const FETCH_WAREHOUSE_LIST_CHIP_FILTER = "FETCH_WAREHOUSE_LIST_CHIP_FILTER";

// refillList.action
export const FETCH_RETURN_ORDER_LIST = "FETCH_RETURN_ORDER_LIST";
export const RESET_RETURN_ORDER_LIST = "RESET_REFILL_LIST";

// refillView.action
export const FETCH_REFILL = "FETCH_REFILL";
export const RESET_REFILL = "RESET_REFILL";

// TopUpView.action
export const FETCH_TOPUP = "FETCH_TOPUP";
export const RESET_TOPUP = "RESET_TOPUP";

// couponList.action
export const FETCH_COUPON_LIST = "FETCH_COUPON_LIST";

// discountList.action
export const FETCH_DISCOUNT_LIST = "FETCH_DISCOUNT_LIST";

//vending machine tags.action
export const FETCH_VENDING_MACHINE_TAGS = "FETCH_VENDING_MACHINE_TAGS";
export const RESET_VENDING_MACHINE_TAGS = "RESET_VENDING_MACHINE_TAGS";

// couponView.action
export const FETCH_COUPON = "FETCH_COUPON";
export const RESET_COUPON = "RESET_COUPON";

// couponView.action
export const FETCH_DISCOUNT = "FETCH_DISCOUNT";
export const RESET_DISCOUNT = "RESET_DISCOUNT";

// deliveryPersonList.action
export const FETCH_DELIVERY_PERSON_LIST = "FETCH_DELIVERY_PERSON_LIST";
export const RESET_DELIVERY_PERSON_LIST = "RESET_DELIVERY_PERSON_LIST";

// refillpartnerList.action
export const FETCH_REFILL_PARTNER_LIST = "FETCH_REFILL_PARTNER_LIST";
export const RESET_REFILL_PARTNER_LIST = "RESET_REFILL_PARTNER_LIST";

// technicianPartnerList.action
export const FETCH_TECHNICIAN_PARTNER_LIST = "FETCH_TECHNICIAN_PARTNER_LIST";
export const RESET_TECHNICIAN_PARTNER_LIST = "RESET_TECHNICIAN_PARTNER_LIST";

// refillpartnerList.action
export const FETCH_LINKED_REFILL_PARTNER_LIST =
  "FETCH_LINKED_REFILL_PARTNER_LIST";
export const RESET_LINKED_REFILL_PARTNER_LIST =
  "RESET_LINKED_REFILL_PARTNER_LIST";

// deliveryPersonView.action
export const FETCH_DELIVERY_PERSON = "FETCH_DELIVERY_PERSON";
export const RESET_DELIVERY_PERSON = "RESET_DELIVERY_PERSON";

// refillpartnerView.action
export const FETCH_REFILL_PARTNER = "FETCH_REFILL_PARTNER";
export const RESET_REFILL_PARTNER = "RESET_REFILL_PARTNER";


export const FETCH_TECHNICIAN_PARTNER = "FETCH_TECHNICIAN_PARTNER";
export const RESET_TECHNICIAN_PARTNER = "RESET_TECHNICIAN_PARTNER";

export const FETCH_TECHNICIAN_TRANSACTION_LIST = "FETCH_TECHNICIAN_TRANSACTION_LIST";
export const RESET_TECHNICIAN_TRANSACTION_LIST = "RESET_TECHNICIAN_TRANSACTION_LIST";


// dashboard.action
export const FETCH_DASHBOARD_DATA = "FETCH_DASHBOARD_DATA";
export const FETCH_TOP_PRODUCTS = "FETCH_TOP_PRODUCTS";
export const FETCH_TOP_BRANDS = "FETCH_TOP_BRANDS";
export const FETCH_TOP_FRANCHISES = "FETCH_TOP_FRANCHISES";
export const FETCH_TOP_VM = "FETCH_TOP_VM";
export const FETCH_SHIPPING_ANALYTICS = "FETCH_SHIPPING_ANALYTICS";
export const FETCH_PURCHASE_ANALYTICS = "FETCH_PURCHASE_ANALYTICS";
export const FETCH_PAYMENT_MODE_ANALYTICS = "FETCH_PAYMENT_MODE_ANALYTICS";
export const FETCH_TOP_RETAILERS = "FETCH_TOP_RETAILERS";

// orderList.action
export const FETCH_ORDER_LIST = "FETCH_ORDER_LIST";
export const FETCH_DIRECT_SALE_LIST = "FETCH_DIRECT_SALE_LIST";

// orderView.action
export const FETCH_ORDER = "FETCH_ORDER";
export const RESET_ORDER = "RESET_ORDER";

// me.action
export const FETCH_ME = "FETCH_ME";
export const RESET_ME = "RESET_ME";

// vmfeedback.action
export const FETCH_VM_FEEDBACKS = "FETCH_VM_FEEDBACKS";

// productFeedback.action
export const FETCH_PRODUCT_FEEDBACKS = "FETCH_PRODUCT_FEEDBACKS";

// productRequest.action
export const FETCH_PRODUCT_REQUESTS = "FETCH_PRODUCT_REQUESTS";
export const RESET_PRODUCT_REQUESTS_VIEW = "RESET_PRODUCT_REQUESTS_VIEW";
export const FETCH_PRODUCT_REQUESTS_VIEW = "FETCH_PRODUCT_REQUESTS_VIEW";

// cancelConfirm.action
export const SET_FORM_DIRTINESS = "SET_FORM_DIRTINESS";
export const RESET_FORM_DIRTINESS = "RESET_FORM_DIRTINESS";
export const CHECK_SHOW_MODAL = "CHECK_SHOW_MODAL";
export const RESET_SHOW_MODAL = "RESET_SHOW_MODAL";
export const RESET_CANCEL_CONFIRM = "RESET_CANCEL_CONFIRM";

// collapseSidebar.action
export const COLLAPSE_SIDEBAR = "COLLAPSE_SIDEBAR";

// notification.action
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_COUNT = "FETCH_NOTIFICATIONS_COUNT";

// salesAnalytics.action
export const FETCH_SALES_ANALYTICS_DATA = "FETCH_SALES_ANALYTICS_DATA";
export const RESET_SALES_ANALYTICS_DATA = "RESET_SALES_ANALYTICS_DATA";

//Modal.action
export const TRIGGER_FEEDBACK_MODAL = "TRIGGER_FEEDBACK_MODAL";
export const TRIGGER_CONFIG_APP_PASSWORD_MODAL =
  "TRIGGER_CONFIG_APP_PASSWORD_MODAL";

//SavedSalesTemplate.action
export const FETCH_SAVED_SALES_TEMPLATE = "FETCH_SAVED_SALES_TEMPLATE";
export const FETCH_SAVED_SALES_REPORT = "FETCH_SAVED_SALES_REPORT";

//DefaultSalesTemplate.action
export const FETCH_DEFAULT_SALES_TEMPLATE = "FETCH_DEFAULT_SALES_TEMPLATE";

//RefundReasionList.action
export const FETCH_REFUND_REASON_LIST = "FETCH_REFUND_REASON_LIST";
export const RESET_REFUND_REASON_LIST = "RESET_REFUND_REASON_LIST";
export const FETCH_REFUNDABLE_ITEMS_LIST = "FETCH_REFUNDABLE_REFUND_LIST";
export const RESET_REFUNDABLE_ITEMS_LIST = "RESET_REFUNDABLE_REFUND_LIST";

//Purchase order management
export const FETCH_PURCHASE_ORDER_LIST = "FETCH_PURCHASE_ORDER_LIST";
export const RESET_PURCHASE_ORDER_LIST = "RESET_PURCHASE_ORDER_LIST";
export const FETCH_PURCHASE_ORDER = "FETCH_PURCHASE_ORDER";
export const RESET_PURCHASE_ORDER = "RESET_PURCHASE_ORDER";

//Purchase return list
export const FETCH_PURCHASE_RETURN_LIST = "FETCH_PURCHASE_RETURN_LIST";
export const RESET_PURCHASE_RETURN_LIST = "RESET_PURCHASE_RETURN_LIST";
export const FETCH_PURCHASE_RETURN = "FETCH_PURCHASE_RETURN";
export const RESET_PURCHASE_RETURN = "RESET_PURCHASE_RETURN";

//Supplier management.
export const FETCH_SUPPLIER_LIST = "FETCH_SUPPLIER_LIST";
export const RESET_SUPPLIER_LIST = "RESET_SUPPLIER_LIST";
export const FETCH_SUPPLIER = "FETCH_SUPPLIER";
export const RESET_SUPPLIER = "RESET_SUPPLIER";

//Store manager management.
export const FETCH_STORE_MANAGERS_LIST = "FETCH_STORE_MANAGERS_LIST";
export const RESET_STORE_MANAGERS_LIST = "RESET_STORE_MANAGERS_LIST";
export const FETCH_STORE_MANAGER = "FETCH_STORE_MANAGER";
export const RESET_STORE_MANAGER = "RESET_STORE_MANAGER";

//Vending Machine Template.
export const FETCH_VM_TEMPLATE_LIST = "FETCH_VENDING_MACHINE_TEMPLATES";
export const RESET_VM_TEMPLATE_LIST = "RESET_VENDING_MACHINE_TEMPLATES";
export const FETCH_VM_TEMPLATE_NAME_LIST = "FETCH_VM_TEMPLATE_NAME_LIST";
export const RESET_VM_TEMPLATE_NAME_LIST = "RESET_VM_TEMPLATE_NAME_LIST";
export const FETCH_VM_TEMPLATE = "FETCH_VENDING_MACHINE_TEMPLATE";
export const RESET_VM_TEMPLATE = "RESET_VENDING_MACHINE_TEMPLATE";

//Vending Machine Template.
export const FETCH_PLANOGRAM_TEMPLATE_LIST = "FETCH_PLANOGRAM_TEMPLATES";
export const RESET_PLANOGRAM_TEMPLATE_LIST = "RESET_PLANOGRAM_TEMPLATES";
export const FETCH_PLANOGRAM_TEMPLATE = "FETCH_PLANOGRAM_TEMPLATE";
export const RESET_PLANOGRAM_TEMPLATE = "RESET_PLANOGRAM_TEMPLATE";

//Planogram Template List By VM Template
export const FETCH_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE =
  "FETCH_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE";
export const RESET_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE =
  "RESET_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE";

//Bulk Refill.
export const FETCH_BULK_REFILL_LIST = "FETCH_BULK_REFILL_LIST";
export const RESET_BULK_REFILL_LIST = "RESET_BULK_REFILL_LIST";
export const FETCH_BULK_REFILL = "FETCH_BULK_REFILL";
export const RESET_BULK_REFILL = "RESET_BULK_REFILL";

//VM settings templates.
export const FETCH_VM_SETTINGS_LIST = "FETCH_VM_SETTINGS_LIST";
export const RESET_VM_SETTINGS_LIST = "RESET_VM_SETTINGS_LIST";
export const FETCH_VM_SETTINGS = "FETCH_VM_SETTINGS";
export const RESET_VM_SETTINGS = "RESET_VM_SETTINGS";

//Carrier board
export const FETCH_CARRIER_BOARD_LIST = "FETCH_CARRIER_BOARD_LIST";
export const RESET_CARRIER_BOARD_LIST = "RESET_CARRIER_BOARD_LIST";

//Return Order View
export const FETCH_RETURN_ORDER = "FETCH_RETURN_ORDER";
export const RESET_RETURN_ORDER = "RESET_RETURN_ORDER";

//Material transfer View
export const FETCH_MATERIAL_TRANSFER = "FETCH_MATERIAL_TRANSFER";
export const RESET_MATERIAL_TRANSFER = "RESET_MATERIAL_TRANSFER";

//Sale order View
export const FETCH_SALE_ORDER = "FETCH_SALE_ORDER";
export const RESET_SALE_ORDER = "RESET_SALE_ORDER";

//Cash Collection order View
export const FETCH_CASH_COLLECTION_ORDER = "FETCH_CASH_COLLECTION_ORDER";
export const RESET_CASH_COLLECTION_ORDER = "RESET_CASH_COLLECTION_ORDER";

//Request order View
export const FETCH_REQUEST_ORDER = "FETCH_REQUEST_ORDER";
export const RESET_REQUEST_ORDER = "RESET_REQUEST_ORDER";

//Store Return Overview
export const FETCH_STORE_RETURN_OVERVIEW = "FETCH_STORE_RETURN_OVERVIEW";
export const RESET_STORE_RETURN_OVERVIEW = "RESET_STORE_RETURN_OVERVIEW";

//VM brand and models list
export const FETCH_VM_BRAND_MODEL_LIST = "FETCH_VM_BRAND_MODEL_LIST";
export const RESET_VM_BRAND_MODEL_LIST = "RESET_VM_BRAND_MODEL_LIST";

//VM machine types
export const FETCH_VM_TYPE_LIST = "FETCH_VM_TYPE_LIST";
export const RESET_VM_TYPE_LIST = "RESET_VM_TYPE_LIST";

//Network device types.
export const FETCH_NETWORK_DEVICE_TYPE_LIST = "FETCH_NETWORK_DEVICE_TYPE_LIST";
export const RESET_NETWORK_DEVICE_TYPE_LIST = "RESET_NETWORK_DEVICE_TYPE_LIST";

//Transaction report columns
export const FETCH_TRANSACTION_REPORT_COLUMNS_LIST =
  "FETCH_TRANSACTION_REPORT_COLUMNS_LIST";
export const RESET_TRANSACTION_REPORT_COLUMNS_LIST =
  "RESET_TRANSACTION_REPORT_COLUMNS_LIST";

// store Return Order
export const FETCH_STORE_RETURN_ORDER = "FETCH_STORE_RETURN_ORDER";
export const RESET_STORE_RETURN_ORDER = "RESET_STORE_RETURN_ORDER";

export const FETCH_BRAND_LIST = "FETCH_BRAND_LIST";
export const RESET_BRAND_LIST = "RESET_BRAND_LIST";

//report list
export const FETCH_REPORT_LIST = "FETCH_REPORT_LIST";
export const RESET_REPORT_LIST = "RESET_REPORT_LIST";

// report view
export const FETCH_REPORT = "FETCH_REPORT";
export const RESET_REPORT = "RESET_REPORT";

// discarded bin overview
export const FETCH_DISCARD_BIN = "FETCH_DISCARD_BIN";
export const RESET_DISCARD_BIN = "RESET_DISCARD_BIN";

// tally inventory overview
export const FETCH_TALLY_INVENTORY = "FETCH_TALLY_INVENTORY";
export const RESET_TALLY_INVENTORY = "RESET_TALLY_INVENTORY";

// supplier return overview
export const FETCH_SUPPLIER_RETURN = "FETCH_SUPPLIER_RETURN";
export const RESET_SUPPLIER_RETURN = "RESET_SUPPLIER_RETURN";

// inventory.action
export const FETCH_CASH_ORDER = "FETCH_CASH_ORDER";
export const RESET_CASH_ORDER = "RESET_CASH_ORDER";

export const FETCH_CASH_ORDER_DETAILS = "FETCH_CASH_ORDER_DETAILS";
export const RESET_CASH_ORDER_DETAILS = "RESET_CASH_ORDER_DETAILS";

export const FETCH_CUSTOMER_FEEDBACK_LIST = "FETCH_CUSTOMER_FEEDBACK_LIST";
export const RESET_CUSTOMER_FEEDBACK_LIST = "RESET_CUSTOMER_FEEDBACK_LIST";

export const FETCH_ADVERTISEMENT = "FETCH_ADVERTISEMENT";
export const RESET_ADVERTISEMENT = "RESET_ADVERTISEMENT";

export const FETCH_ADVERTISEMENT_LIST = "FETCH_ADVERTISEMENT_LIST";
export const RESET_ADVERTISEMENT_LIST = "RESET_ADVERTISEMENT_LIST";

export const FETCH_DAY_DATE_WISE_SALES_DATA = "FETCH_DAY_DATE_WISE_SALES_DATA";
export const RESET_DAY_DATE_WISE_SALES_DATA = "RESET_DAY_DATE_WISE_SALES_DATA";

export const FETCH_HOUR_WISE_SALES_DATA = "FETCH_HOUR_WISE_SALES_DATA";
export const RESET_HOUR_WISE_SALES_DATA = "RESET_HOUR_WISE_SALES_DATA";

export const FETCH_TOP_FAILURE_VM_DATA = "FETCH_TOP_FAILURE_VM_DATA";
export const RESET_TOP_FAILURE_VM_DATA = "RESET_TOP_FAILURE_VM_DATA";

export const FETCH_TOP_SELLING_PRODUCTS = "FETCH_TOP_SELLING_PRODUCTS";
export const RESET_TOP_SELLING_PRODUCTS = "RESET_TOP_SELLING_PRODUCTS";

export const FETCH_TOP_SELLING_BRANDS = "FETCH_TOP_SELLING_BRANDS";
export const RESET_TOP_SELLING_BRANDS = "RESET_TOP_SELLING_BRANDS";

export const FETCH_VM_PURCHASE_ANALYTICS = "FETCH_VM_PURCHASE_ANALYTICS";
export const RESET_VM_PURCHASE_ANALYTICS = "RESET_VM_PURCHASE_ANALYTICS";

export const FETCH_VM_REVENUE_ANALYTICS = "FETCH_VM_REVENUE_ANALYTICS";
export const RESET_VM_REVENUE_ANALYTICS = "RESET_VM_REVENUE_ANALYTICS";

export const FETCH_CUSTOMER_PLATFORM_LIST = "FETCH_CUSTOMER_PLATFORM_LIST";
export const RESET_CUSTOMER_PLATFORM_LIST = "RESET_CUSTOMER_PLATFORM_LIST";

// negativeItemList.action
export const FETCH_NEGATIVE_ITEM_LIST = "FETCH_NEGATIVE_ITEM_LIST";
export const RESET_NEGATIVE_ITEM_LIST = "RESET_NEGATIVE_ITEM_LIST";

// negativeItemView.action
export const FETCH_NEGATIVE_ITEM = "FETCH_NEGATIVE_ITEM";
export const RESET_NEGATIVE_ITEM = "RESET_NEGATIVE_ITEM";

// actionHistoryList.action
export const FETCH_ACTION_HISTORY_LIST = "FETCH_ACTION_HISTORY_LIST";
export const RESET_ACTION_HISTORY_LIST = "RESET_ACTION_HISTORY_LIST";

//warehouseOrderListFilter.action
export const FETCH_WAREHOUSE_ORDER_LIST_FILTER = "FETCH_WAREHOUSE_ORDER_LIST_FILTER";
export const RESET_WAREHOUSE_ORDER_LIST_FILTER = "RESET_WAREHOUSE_ORDER_LIST_FILTER";
export const FETCH_WAREHOUSE_ORDER_LIST_CHIP_FILTER = "FETCH_WAREHOUSE_ORDER_LIST_CHIP_FILTER";

//purchaseOrderListFilter.action
export const FETCH_PURCHASE_ORDER_LIST_FILTER = "FETCH_PURCHASE_ORDER_LIST_FILTER";
export const RESET_PURCHASE_ORDER_LIST_FILTER = "RESET_PURCHASE_ORDER_LIST_FILTER";
export const FETCH_PURCHASE_ORDER_LIST_CHIP_FILTER = "FETCH_PURCHASE_ORDER_LIST_CHIP_FILTER";

//actionHistoryListFilter.action
export const FETCH_ACTION_HISTORY_LIST_FILTER = "FETCH_ACTION_HISTORY_LIST_FILTER";
export const RESET_ACTION_HISTORY_LIST_FILTER = "RESET_ACTION_HISTORY_LIST_FILTER";
export const FETCH_ACTION_HISTORY_LIST_CHIP_FILTER = "FETCH_ACTION_HISTORY_LIST_CHIP_FILTER";

//orderListFilter.action
export const FETCH_ORDER_LIST_FILTER = "FETCH_ORDER_LIST_FILTER";
export const RESET_ORDER_LIST_FILTER = "RESET_ORDER_LIST_FILTER";
export const FETCH_ORDER_LIST_CHIP_FILTER = "FETCH_ORDER_LIST_CHIP_FILTER";
